import React from 'react';
import TVStoryboardPage from '../components/tv/TVStoryboardPage';

/** テレビ向けデモのページエントリ（ルート: /tv-demo） */
function TVDemoPage() {
  return <TVStoryboardPage />;
}

export default TVDemoPage;
